module.exports = __webpack_public_path__ + "static/media/readIcon.2bca976b.svg";